import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const browser_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M2.5,20.5 L21.5,20.5 L21.5,5.5 L2.5,5.5 L2.5,20.5 Z M2.5,10.5 L21.5,10.5 M11.5,8 C11.5,8.276
      11.276,8.5 11,8.5 C10.724,8.5 10.5,8.276 10.5,8 C10.5,7.724 10.724,7.5 11,7.5 C11.276,7.5 11.5,
      7.724 11.5,8 Z M8.5,8 C8.5,8.276 8.276,8.5 8,8.5 C7.724,8.5 7.5,8.276 7.5,8 C7.5,7.724 7.724,7.5
      8,7.5 C8.276,7.5 8.5,7.724 8.5,8 Z M5.5,8 C5.5,8.276 5.276,8.5 5,8.5 C4.724,8.5 4.5,8.276 4.5,8
      C4.5,7.724 4.724,7.5 5,7.5 C5.276,7.5 5.5,7.724 5.5,8 Z"
      />
    </svg>
  );
};
